import React from 'react'
import { BarChart, BarChartProps } from 'components/charts/BarChart'
import { DateTime } from 'luxon'
import { CheckinCountByDay } from 'generated/types'

export interface ToolTipItem {
  index: number
  yLabel: string
}

export interface CheckinsByDayChartProps {
  data: CheckinCountByDay[]
  height?: number
}

export const CheckinsByDayChart = ({ data, height }: CheckinsByDayChartProps) => {
  const days = data.map((c) => DateTime.fromISO(c.date)) || []
  const dayLabels = days.map((d) => [d.toFormat('ccc'), d.toFormat('LLL dd')])
  const checkinCount = data.map((c) => c.count) || []

  const config: BarChartProps = {
    data: {
      labels: dayLabels,
      datasets: [
        {
          data: checkinCount,
        },
      ],
    },
    options: {
      tooltips: {
        callbacks: {
          label: (tooltipItem: ToolTipItem) => {
            const checkinLabel = checkinCount[tooltipItem.index] === 1 ? 'checkin' : 'checkins'
            return `${dayLabels[tooltipItem.index].join(', ')} - ${checkinCount[tooltipItem.index]} ${checkinLabel}`
          },
          title: () => '', // makes title blank rather than showing 'undefined'
        },
      },
      scales: {
        xAxes: [
          {
            scaleLabel: {
              labelString: 'Day',
            },
          },
        ],
      },
    },
  }

  return (
    <BarChart {...config} height={height} />
  )
}
